<form #fileForm
    method="POST"
    enctype="multipart/form-data"
    (dragover)="onDragOver($event)"
    (dragleave)="onDragLeave($event)"
    (drop)="onDrop($event)"
    class="margin"
    [attr.data-qa-id]="'upload-file-form' + (qaComponentSuffix ? '-' + qaComponentSuffix : '')">
    <div *ngIf="editModeFlag" class="drop-area" [ngClass]="{'drop-area-hover': isDragging}" [attr.data-qa-id]="'upload-file-drop-area' + (qaComponentSuffix ? '-' + qaComponentSuffix : '')">
        <input type="file" id="file-input" #fileInput (change)="addSelectedFiles()" multiple [attr.data-qa-id]="'upload-file-input' + (qaComponentSuffix ? '-' + qaComponentSuffix : '')">

        <div class="drop-area-actions">
            <div class="drag-and-drop">
                <div>
                    <mat-icon class="drag-and-drop-icon">backup</mat-icon>
                </div>
                <div class="drag-and-drop-text">
                    Drag & Drop
                </div>
            </div>
            <div class="dnd-or">
                OR
            </div>
            <div class="dnd-browse">
                <button mat-raised-button (click)="browse()" class="browse-button" [attr.data-qa-id]="'upload-file-browser' + (qaComponentSuffix ? '-' + qaComponentSuffix : '')">
                    BROWSE
                </button>
            </div>
        </div>
        <div class="drop-area-hint">
            <div>
                <mat-icon class="drop-area-hint-icon">emoji_objects</mat-icon>
            </div>
            <div class="drop-area-hint-text">
                Helpful Tip: You can add multiple files at once!
            </div>
        </div>
    </div>
</form>

<mat-table class="mat-table--compact" [dataSource]="dataSource" [attr.data-qa-id]="'upload-file-table' + (qaComponentSuffix ? '-' + qaComponentSuffix : '')">
    <ng-container matColumnDef="title">
        <mat-header-cell *matHeaderCellDef>
            Title
        </mat-header-cell>
        <mat-cell [ngClass]="'cell-padding-left'" *matCellDef="let element; let i = index">
            <ng-container *ngIf="isTitleEditable else showTitleText">
                <input (input)="onTitleChange($event, i)" maxlength="150"
                    matInput class="input-cell"
                    placeholder="Specify a title" name="title" autocomplete="off"
                    value="{{element?.title}}" [attr.data-qa-id]="'upload-file-table-title' + (qaComponentSuffix ? '-' + qaComponentSuffix : '')">
            </ng-container>

            <ng-template #showTitleText>
                <span *ngIf="isTitleClickable" matTooltip="Download attachment" class="nova__link inline-ellipsis" (click)="onClickAttachment(element)" [attr.data-qa-id]="'upload-file-table-title-download-' + i + (qaComponentSuffix ? '-' + qaComponentSuffix : '')">
                    {{element?.title}}
                </span>
                <span *ngIf="!isTitleClickable" [attr.data-qa-id]="'upload-file-table-title-' + i + (qaComponentSuffix ? '-' + qaComponentSuffix : '')">
                    {{element?.title}}
                </span>
            </ng-template>
            <small *ngIf="element.pending" class="ml-2" [attr.data-qa-id]="'upload-file-table-pending-' + i + (qaComponentSuffix ? '-' + qaComponentSuffix : '')">pending</small>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="file" *ngIf="fileColumnNeeded">
        <mat-header-cell *matHeaderCellDef="let i = index" [attr.data-qa-id]="'upload-file-table-file-name-header-' + i + (qaComponentSuffix ? '-' + qaComponentSuffix : '')">
            File
        </mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index" [attr.data-qa-id]="'upload-file-table-file-name-' + i + (qaComponentSuffix ? '-' + qaComponentSuffix : '')">
            {{element?.file?.name}}
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="delete">
        <mat-header-cell *matHeaderCellDef class="delete-cell"></mat-header-cell>
        <mat-cell *matCellDef="let element; let i = index" class="delete-cell">
            <button *ngIf="editModeFlag"
                mat-icon-button color="primary">
                <mat-icon (click)="onRemoveFile(i)" [attr.data-qa-id]="'upload-file-table-delete-' + i + (qaComponentSuffix ? '-' + qaComponentSuffix : '')">delete</mat-icon>
            </button>
        </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="definedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: definedColumns"></mat-row>

</mat-table>

<div class="empty-row" *ngIf="dataSource.data.length === 0" [attr.data-qa-id]="'upload-file-no-attachments' + (qaComponentSuffix ? '-' + qaComponentSuffix : '')">No attachments have been uploaded.</div>
